const clean = (string: string): string => {
  return string
    .toString()
    .replace('↵', '')
    .trim()
    .toLocaleLowerCase()
    ;
};

const safeCompare = (source: any, target: any): boolean => {
  return (
    (typeof source === 'boolean' && typeof target === 'boolean') || (source && target)
  ) && clean(source) === clean(target);
};

export default safeCompare;
